import { Breadcrumbs, Link, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

export interface Crumb {
    label: string;
    to?: string;
}

const useStyles = makeStyles(theme => ({
    root: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "flex-end",
        gap: theme.spacing(2),
        marginBottom: theme.spacing(3),
    },
    title: {
        fontWeight: 700,
        wordBreak: "break-word",
    },
    actions: {
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(1),
    },
}));

interface Props {
    title: string;
    subtitle?: React.ReactNode;
    breadcrumbs?: Crumb[];
    actions?: React.ReactNode;
}

export const PageHeader: React.FC<Props> = ({ title, subtitle, breadcrumbs, actions }) => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <div>
                {breadcrumbs && breadcrumbs.length > 0 && (
                    <Breadcrumbs aria-label="breadcrumb" maxItems={6}>
                        {breadcrumbs.map((crumb, index) =>
                            crumb.to ? (
                                <Link key={index} component={RouterLink} to={crumb.to} color="inherit">
                                    {crumb.label}
                                </Link>
                            ) : (
                                <Typography key={index} color="textPrimary">{crumb.label}</Typography>
                            )
                        )}
                    </Breadcrumbs>
                )}
                <Typography variant="h5" component="h1" className={classes.title}>{title}</Typography>
                {subtitle && <Typography variant="body2" color="textSecondary" component="div">{subtitle}</Typography>}
            </div>
            {actions && <div className={classes.actions}>{actions}</div>}
        </div>
    );
};
